export default __webpack_public_path__ + "static/media/bg.927c3b69.svg";